import { Button, Popover, PopoverContent, PopoverTrigger } from '@e2n/ui';
import { YearMonthPopoverContent } from '@/domain/termine/components/YearMonthPicker/YearMonthPopoverContent';
import { YearMonthParams } from '@/domain/termine/type';
import { getMonthNameByDate } from '@/utils/dateFunctions/getDatesOfMonth';
import { useState } from 'react';
import { useParams } from 'react-router-dom';

export function YearMonthPopoverDesktop() {
  const [openPopover, setOpenPopover] = useState(false);
  const { year, month } = useParams();
  const currentMonthAndYear: YearMonthParams = { year, month };
  const monthYearName = currentMonthAndYear.year + currentMonthAndYear.month;
  return (
    <Popover open={openPopover} onOpenChange={setOpenPopover}>
      <PopoverTrigger asChild>
        <Button variant="ghost">
          <span className="hidden sm:inline text-2xl font-extrabold">
            {getMonthNameByDate(monthYearName)}
          </span>
        </Button>
      </PopoverTrigger>
      <PopoverContent className="bg-white w-fit p-4" sideOffset={4}>
        <YearMonthPopoverContent
          currentMonthAndYear={currentMonthAndYear}
          onSelect={() => setOpenPopover(false)}
        />
      </PopoverContent>
    </Popover>
  );
}
